//请自行添加语言资源
const boxReportForm = {
  rfid:'RFID',
  packerCode:'Packer Code',
  customerCode: 'Customer Code',
  itrCode: 'ITR',
  receiveStatus: '签收状态',
  useageStatus: '使用状态',
  scStatus: 'SC状态',
  receiveTime: '签收时间',
  useageTime:'使用时间',
  orderNo:'销售订单号',
  shipTime:'出库时间',
  receivingAddressDetail:'收货地址',
  receivingContact:'收货联系人',
  receivingContactNumber:'收货联系人电话',
  sku:'SKU',
  packerName:'租赁方名称',
  thirdCustomerName:'客户名称',
  email: '联系邮箱',
  msg:{
  }
};
export default boxReportForm



// WEBPACK FOOTER //
// ./src/page/report/boxReportForm/lang/boxReportForm.zh.js